// src/i18n/helper.ts
//
// React-friendly i18n helper that wraps i18next with a thin
// functional API. Components use the `useTranslation` hook from
// react-i18next; this helper is for non-React code (utilities,
// tests) and for explicit language switching.

import i18n from "./index";

export const supportedLanguages = ["en", "fr", "nl"] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

/**
 * Translate a key in the current language.
 * @param key Dot-notation key, e.g. "nav.catalog"
 * @returns Translated string, or the key itself if not found.
 */
export function t(key: string): string {
  return i18n.t(key);
}

/**
 * Switch the active language.
 * @param language Two-letter code, e.g. "en" or "fr"
 */
export async function changeLanguage(language: SupportedLanguage): Promise<void> {
  await i18n.changeLanguage(language);
}

/**
 * Get the currently active language code.
 */
export function currentLanguage(): string {
  return i18n.language;
}